import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cdlg__detail"
}
const _hoisted_2 = { class: "cdlg__actions" }

import { nextTick, ref, watch } from 'vue'
import { useConfirmDialogHost } from '@/composables/useConfirmDialog'


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  setup(__props) {

const uid = `cdlg-${Math.random().toString(36).slice(2, 9)}`
const titleId = `${uid}-title`
const descId = `${uid}-desc`
const panelRef = ref<HTMLElement | null>(null)
const confirmRef = ref<HTMLButtonElement | null>(null)

const {
  open,
  title,
  message,
  detail,
  confirmLabel,
  cancelLabel,
  tone,
  onConfirm,
  onCancel,
} = useConfirmDialogHost()

watch(open, async (value) => {
  if (!value) return
  await nextTick()
  confirmRef.value?.focus()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "cdlg" }, {
      default: _withCtx(() => [
        (_unref(open))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "cdlg",
              role: "alertdialog",
              "aria-modal": "true",
              "aria-labelledby": titleId,
              "aria-describedby": descId,
              onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(onCancel) && _unref(onCancel)(...args)), ["prevent"]), ["esc"]))
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "cdlg__catch",
                "aria-label": "닫기",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onCancel) && _unref(onCancel)(...args)))
              }),
              _createElementVNode("div", {
                class: "cdlg__panel",
                ref_key: "panelRef",
                ref: panelRef
              }, [
                _createElementVNode("h2", {
                  id: titleId,
                  class: "cdlg__title"
                }, _toDisplayString(_unref(title)), 1),
                _createElementVNode("p", {
                  id: descId,
                  class: "cdlg__message"
                }, _toDisplayString(_unref(message)), 1),
                (_unref(detail))
                  ? (_openBlock(), _createElementBlock("pre", _hoisted_1, _toDisplayString(_unref(detail)), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "cdlg__btn",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onCancel) && _unref(onCancel)(...args)))
                  }, _toDisplayString(_unref(cancelLabel)), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["cdlg__btn cdlg__btn--confirm", `is-${_unref(tone)}`]),
                    ref_key: "confirmRef",
                    ref: confirmRef,
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onConfirm) && _unref(onConfirm)(...args)))
                  }, _toDisplayString(_unref(confirmLabel)), 3)
                ])
              ], 512)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})